export function IconAnalysis({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width="16"
      height="16"
      fill="none"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m5.88.482 1.08 1.16-1.85 1.725-1.08-1.16L5.88.483Zm-.307 9.9a16.98 16.98 0 0 0-1.59 3.09c-.797 2.042-1.118 4.059-.862 5.395a.8.8 0 0 0 .785.65h10.05a.8.8 0 0 0 .8-.8v-2.605h2.21v-1.6h-6.018v1.6h2.209v1.805H4.635c-.01-.96.244-2.338.839-3.864.331-.847.759-1.716 1.284-2.556.37.182.785.284 1.224.284.71 0 1.358-.267 1.848-.706l1.23 1.319a.8.8 0 0 0 1.13.04l3.263-3.043a.8.8 0 0 0 .04-1.13l-6.15-6.596a.8.8 0 0 0-1.132-.04L4.95 4.667a.8.8 0 0 0-.04 1.131L6.05 7.02a2.765 2.765 0 0 0-.84 1.988c0 .5.132.969.364 1.374ZM7.537 6.27a2.773 2.773 0 0 1 3.145 3.373l1.003 1.075 2.092-1.951-5.06-5.426-2.092 1.951.912.978Zm-.743 2.738a1.189 1.189 0 1 1 2.377 0 1.189 1.189 0 0 1-2.377 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
